import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'financial-performance',
    description:
      'Track the financial performance at Attain Partners including revenue, expenses, and gross margin.',
    icon: 'weight2',
    name: 'Financial Performance',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
